var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sub-menu-item__container"},[_c('router-link',{staticClass:"title",attrs:{"to":_vm.path}},[_vm._v(_vm._s(_vm.title))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }